/**
 * 统一跳转工具
 * linkType:
 *   1  产品类型列表  linkValue=productTypeId
 *   2  产品详情     linkValue=productId
 *   3  资讯详情     linkValue=articleId
 *   4  外部链接     linkValue=url
 *   5  无跳转
 *   6  资讯类型列表  linkValue=articleTypeId
 *   7  自定义页面   linkValue=pageConfigId（本次 H5 范围内暂不支持，忽略并 console.warn）
 *   8  产品列表     linkValue=productTypeId（可空）
 *   9  资讯列表     linkValue=articleTypeId（可空）
 *  10  外部小程序   linkValue=path, extraValue=appId（H5 无法跳转小程序，降级为外部链接打开）
 */
export function navigate(router, linkType, linkValue, extraValue) {
  if (!linkType || linkType === 5) return

  switch (linkType) {
    case 1:
      router.push(linkValue ? `/products/${linkValue}` : '/products')
      break
    case 2:
      router.push({ path: `/product/${linkValue}` })
      break
    case 3:
      router.push({ path: `/article/${linkValue}` })
      break
    case 4:
      if (linkValue) window.open(linkValue, '_blank')
      break
    case 6:
      router.push({ path: '/articles', query: { articleTypeId: linkValue } })
      break
    case 7:
      // 自定义落地页（circum）不在本次 H5 范围内，忽略
      console.warn('自定义页面跳转暂不支持:', linkValue)
      break
    case 8:
      router.push(linkValue ? `/products/${linkValue}` : '/products')
      break
    case 9: {
      const query = linkValue ? { articleTypeId: linkValue } : {}
      router.push({ path: '/articles', query })
      break
    }
    case 10:
      // H5 端无法跳转外部小程序，降级提示或忽略
      if (linkValue) window.open(linkValue, '_blank')
      break
    default:
      break
  }
}
